var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"elevation-1 mb-6 rounded-lg mt-0"},[_c('v-card-title',{staticClass:"pa-7"},[_vm._v(" Přehled promo kódů "),_c('v-spacer')],1),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.orderHeadersByRole,"items":_vm.promoCode.items,"options":_vm.promoCode.options,"server-items-length":_vm.promoCode.serverItemsLength,"loading":_vm.promoCode.loading,"item-key":"id"},on:{"update:options":function($event){return _vm.$set(_vm.promoCode, "options", $event)}},scopedSlots:_vm._u([{key:"item.orderId",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{
            name: 'orders.detail',
            params: {
              orderId: item.orderId,
            },
          }}},[_vm._v(" "+_vm._s(item.orderId)+" ")])]}},{key:"item.gift.id",fn:function(ref){
          var item = ref.item;
return [_c('router-link',{attrs:{"to":{
            name: 'gifts.detail',
            params: {
              giftId: item.gift.id,
            },
          }}},[_vm._v(" "+_vm._s(item.gift.id)+" ")])]}},{key:"item.used",fn:function(ref){
          var item = ref.item;
return [_c('YesNo',{attrs:{"value":item.used}})]}},{key:"item.createdAt",fn:function(ref){
          var item = ref.item;
return [_c('DateTime',{attrs:{"single-line":false,"datetime":item.createdAt}})]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }